(() => {
  const announcements = document.querySelector('[data-announcements]');
  if (announcements) {
    const messages = [...announcements.querySelectorAll('.announcement-message')];
    const control = announcements.querySelector('.announcement-toggle');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0, paused = false, timer;
    const mode = () => {
      clearInterval(timer);
      announcements.classList.toggle('announcements-ready', !reduced.matches);
      control.hidden = reduced.matches;
      messages.forEach((message, index) => { message.hidden = !reduced.matches && index !== current; });
      if (!reduced.matches) timer = setInterval(() => {
        if (paused || document.hidden || announcements.matches(':hover,:focus-within')) return;
        messages[current].hidden = true;
        current = (current + 1) % messages.length;
        messages[current].hidden = false;
      }, 7500);
    };
    control.addEventListener('click', () => {
      paused = !paused;
      control.setAttribute('aria-pressed', String(paused));
      control.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      control.querySelector('[data-pause-icon]').hidden = paused;
      control.querySelector('[data-play-icon]').hidden = !paused;
    });
    reduced.addEventListener('change', mode);
    mode();
  }
  document.querySelectorAll('[data-faq]').forEach(faq => {
    const tabs = faq.querySelector('[data-faq-tabs]');
    const buttons = [...tabs.querySelectorAll('button')];
    const panels = buttons.map(button => document.getElementById(button.dataset.faqTarget));
    if (panels.some(panel => !panel)) return;
    const activate = index => {
      buttons.forEach((button, i) => { button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
    };
    tabs.setAttribute('role', 'tablist');
    buttons.forEach((button, index) => {
      button.id = button.dataset.faqTarget + '-tab';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', button.id);
      panels[index].tabIndex = 0;
      button.addEventListener('click', () => activate(index));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault(); activate(next); buttons[next].focus();
      });
    });
    faq.classList.add('faq-enhanced'); tabs.hidden = false; activate(0);
  });
  const header = document.querySelector('.site-header');
  const cartLink = header?.querySelector('.cart-link');
  if (cartLink) addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    try {
      const url = new URL(cartLink.href); url.pathname += '.js'; url.search = '';
      const response = await fetch(url, {headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count) || !Number.isFinite(cart.total_price) || !/^[A-Z]{3}$/.test(cart.currency)) return;
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: cart.currency}).format(cart.total_price / 100) + ' ' + cart.currency;
      cartLink.querySelector('.cart-count').textContent = cart.item_count;
      cartLink.querySelector('.cart-total').textContent = amount;
      cartLink.setAttribute('aria-label', `Cart, ${cart.item_count} items, ${amount}`);
    } catch (_) { /* Keep the server-rendered state if a background refresh fails. */ }
  });
  const toggle = header?.querySelector('.menu-toggle');
  if (toggle) {
    toggle.hidden = false;
    document.documentElement.classList.add('storefront-ready');
    const closeMenu = () => {
      header.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && header.classList.contains('menu-open')) { closeMenu(); toggle.focus(); }
    });
    header.querySelector('.primary-nav')?.addEventListener('click', event => {
      if (event.target.closest('a')) closeMenu();
    });
    matchMedia('(min-width: 901px)').addEventListener('change', closeMenu);
  }
  // Successful submit controls must remain enabled so return_to is posted.
  const forms = document.querySelectorAll('[data-purchase-form]');
  forms.forEach(form => form.addEventListener('submit', event => {
    if (form.dataset.submitting) { event.preventDefault(); return; }
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    const button = event.submitter;
    if (button) {
      button.dataset.originalLabel = button.textContent;
      button.textContent = button.name === 'return_to' ? 'Opening checkout…' : 'Adding…';
      button.setAttribute('aria-disabled', 'true');
    }
  }));
  addEventListener('pageshow', () => {
    forms.forEach(form => { delete form.dataset.submitting; form.removeAttribute('aria-busy'); });
    document.querySelectorAll('[data-original-label]').forEach(button => {
      button.textContent = button.dataset.originalLabel;
      delete button.dataset.originalLabel;
      button.removeAttribute('aria-disabled');
    });
  });
  const sticky = document.querySelector('[data-sticky-purchase]');
  const primary = document.querySelector('[data-main-buy]');
  if (sticky && primary && 'IntersectionObserver' in window) {
    const footer = document.querySelector('.site-footer');
    const update = () => {
      const primaryAbove = primary.getBoundingClientRect().bottom <= 0;
      // Focus/anchor jumps can precede observer callbacks; use current geometry.
      const footerRect = footer?.getBoundingClientRect();
      const footerVisible = footerRect && footerRect.top < innerHeight && footerRect.bottom > 0;
      const editing = document.activeElement?.matches('input,textarea,select');
      const privacy = document.querySelector('#shopify-pc__banner');
      const privacyVisible = privacy && privacy.getClientRects().length > 0;
      sticky.hidden = !(primaryAbove && !footerVisible && !editing && !privacyVisible);
      document.body.classList.toggle('has-sticky-purchase', !sticky.hidden);
    };
    new IntersectionObserver(update).observe(primary);
    if (footer) new IntersectionObserver(update).observe(footer);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', () => setTimeout(update, 0));
    addEventListener('resize', update);
    let scrollPending = false;
    addEventListener('scroll', () => {
      if (scrollPending) return;
      scrollPending = true;
      requestAnimationFrame(() => { scrollPending = false; update(); });
    }, {passive: true});
    document.addEventListener('change', event => {
      if (event.target.matches('[data-variant-select]')) {
        const price = event.target.selectedOptions[0]?.dataset.price;
        if (price) sticky.querySelector('[data-sticky-price]').textContent = price;
      }
    });
  }
})();

// Keep the mobile email teaser above the product purchase bar.
(() => {
  const bar = document.querySelector('[data-sticky-purchase]');
  if (!bar || bar.dataset.formsClearanceInitialized) return;
  bar.dataset.formsClearanceInitialized = 'true';
  let queued = false;
  const update = () => {
    queued = false;
    const rect = bar.getBoundingClientRect();
    const visible = matchMedia('(max-width: 760px)').matches && !bar.hidden && rect.height > 0 && rect.top < innerHeight;
    const clearance = visible ? Math.ceil(innerHeight - rect.top) + 12 : 0;
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const shadow = host.shadowRoot;
      if (!shadow) return;
      if (!shadow.getElementById('StreamXFormsPurchaseClearance')) {
        const style = document.createElement('style');
        style.id = 'StreamXFormsPurchaseClearance';
        style.textContent = '@media (max-width: 760px) { [data-form-root][data-layout="floating"][data-current-step="tease"][data-position^="bottom"] { bottom: var(--streamx-purchase-clearance, 0px) !important; } }';
        shadow.appendChild(style);
      }
      host.style.setProperty('--streamx-purchase-clearance', clearance + 'px');
    });
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  new MutationObserver(queue).observe(document.body, {childList: true, subtree: true});
  new MutationObserver(queue).observe(bar, {attributes: true, attributeFilter: ['hidden']});
  if ('ResizeObserver' in window) new ResizeObserver(queue).observe(bar);
  addEventListener('resize', queue);
  update();
})();
